/*
 * useChartWidth: the width a chart draws at.
 *
 * A chart draws at a width of its own, which the page scales to the room it
 * is given. In the phone layout (usePhoneLayout) a drawing wider than its room
 * is drawn at the room's width instead of shrunk into it, so its type stays
 * the size it was set in rather than shrinking past reading. Returns a ref for
 * the element the chart fills, and the width to draw at.
 */
import useElementWidth from "./useElementWidth";
import usePhoneLayout from "./usePhoneLayout";

export default function useChartWidth(width) {
  const phone = usePhoneLayout();
  const [ref, room] = useElementWidth(width);
  return [ref, phone ? Math.min(width, Math.floor(room)) : width];
}
